import { render, staticRenderFns } from "./KgjtWebsiteExpertsEdit.vue?vue&type=template&id=7993b27c&scoped=true&"
import script from "./KgjtWebsiteExpertsEdit.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteExpertsEdit.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteExpertsEdit.vue?vue&type=style&index=0&id=7993b27c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7993b27c",
  null
  
)

export default component.exports